import request from "_private/utils/request";

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
    return request({
        url: "/base/storageAreaLabel/findByPage",
        method: "post",
        data
    });
}

/**
 * 校验数据唯一性
 */
export function CheckNameUniqueData(data) {
    return request({
        url: "/base/storageAreaLabel/checkNameUniqueData",
        method: "post",
        data
    });
}

/**
 * 保存库区监测点信息
 * @param {*} data
 */
export function SaveStorageAreaLabelInfo(data) {
  return request({
      url: "/base/storageAreaLabel/saveStorageAreaLabelInfo",
      method: "post",
      data
  });
}

/**
 * 查询单个库区监测点信息
 * @param {*} data
 */
export function FindStorageAreaLabelInfoById(data) {
  return request({
      url: "/base/storageAreaLabel/findStorageAreaLabelInfoById",
      method: "post",
      data
  });
}

/**
 * 删除库区监测点信息
 * @param {*} data
 */
export function DeleteStorageAreaLabelInfoByIds(data) {
  return request({
      url: "/base/storageAreaLabel/deleteStorageAreaLabelInfoByIds",
      method: "post",
      data
  });
}



